module.exports = __webpack_public_path__ + "media/images/favicon/favicon-96x96-3a398d511bb1799fb47aabf15830440a.png";